import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ILookupService, IdValuePair, LookupCriteria } from "@tylertech/tyler-api-types";
@Injectable()
export class UBAccountLookupService implements ILookupService<IdValuePair>
{
    private readonly $apiService = inject(ApiService);


    Lookup(criteria: LookupCriteria): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth("IAccountService/LookupAccount", criteria);
    }
}
